export default {"src":"/canvas/_next/static/media/icon-outlookcom-t5.e5c133ae.svg","height":1024,"width":1024,"blurWidth":0,"blurHeight":0};